import styles from "./Sidebar.module.scss";
import { Link, NavLink } from "react-router-dom";
import basket from "../../assets/images/icons/basket.svg";
import orders from "../../assets/images/icons/orders.svg";
import overview from "../../assets/images/icons/overview.svg";
import message from "../../assets/images/icons/message.svg";
import delivery from "../../assets/images/icons/delivery.svg";
import log_out from "../../assets/images/icons/log_out.svg";
import settings from "../../assets/images/icons/settings.svg";
import info from "../../assets/images/icons/info.svg";
import { useState } from "react";
import Modal from "../common/modal/Modal";
import { eraseCookie } from "../../utils/cookies";
import AuthService from "../../api/services/auth.service";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const Sidebar = ({ open, setOpen, collapsed, setCollapsed }: Props) => {
  const [logoutModal, setLogoutModal] = useState(false);
  const { t } = useTranslation("translation");

  const onSubmit = async () => {
    try {
      eraseCookie("StoreDashboardAccessToken");
      AuthService.logout();
    } catch (error: any) {}
  };
  return (
    <>
      {open && (
        <div className={styles.overlay} onClick={() => setOpen(false)} />
      )}
      <aside
        className={`${styles.sidebar} ${open ? styles.open : ""} ${
          collapsed ? styles.collapsed : ""
        }`}
      >
        <div>
          <div className={styles.header}>
            <h1 className={styles.logo}>{collapsed ? "LM" : "Luxmart"}</h1>
            <button
              className={styles.collapseBtn}
              onClick={() => setCollapsed(!collapsed)}
              title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {collapsed ? "»" : "«"}
            </button>
            <button className={styles.closeBtn} onClick={() => setOpen(false)}>
              ✕
            </button>
          </div>
          <nav className={styles.navbar}>
            <ul className={styles.nav_list}>
              <li className={styles.list}>
                <NavLink
                  to="/dashboard"
                  end
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ""}`
                  }
                  onClick={() => setOpen(false)}
                >
                  <img src={overview} alt="" />
                  {!collapsed && <p>{t("overview")}</p>}
                </NavLink>
              </li>
              <li className={styles.list}>
                <NavLink
                  to="/dashboard/info"
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ""}`
                  }
                  onClick={() => setOpen(false)}
                >
                  <img src={info} alt="" />
                  {!collapsed && <p>{t("store_info")}</p>}
                </NavLink>
              </li>
              <li className={styles.list}>
                <NavLink
                  to="/dashboard/products"
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ""}`
                  }
                  onClick={() => setOpen(false)}
                >
                  <img src={basket} alt="" />
                  {!collapsed && <p>{t("products")}</p>}
                </NavLink>
              </li>
              <li className={styles.list}>
                <NavLink
                  to="/dashboard/delivery"
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ""}`
                  }
                  onClick={() => setOpen(false)}
                >
                  <img src={delivery} alt="" />
                  {!collapsed && <p>{t("delivery")}</p>}
                </NavLink>
              </li>

              <li className={styles.list}>
                <NavLink
                  to="/dashboard/orders"
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ""}`
                  }
                  onClick={() => setOpen(false)}
                >
                  <img src={orders} alt="" />
                  {!collapsed && <p>{t("orders")}</p>}
                </NavLink>
              </li>
              <li className={styles.list}>
                <NavLink
                  to="/dashboard/messages"
                  className={({ isActive }) =>
                    `${styles.link} ${isActive ? styles.active : ""}`
                  }
                  onClick={() => setOpen(false)}
                >
                  <img src={message} alt="" />
                  {!collapsed && <p>{t("messages")}</p>}
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
        <div className={styles.footer}>
          <ul className={styles.foot_links}>
            <li className={styles.foot_list}>
              <Link
                to={"/dashboard/settings"}
                className={styles.foot_lik}
                onClick={() => setOpen(false)}
              >
                <img src={settings} alt="" />
                {!collapsed && <p>{t("settings.title")}</p>}
              </Link>
            </li>
            <li
              className={styles.foot_list}
              onClick={() => setLogoutModal(true)}
            >
              <button className={styles.foot_lik}>
                <img src={log_out} alt="" />
                {!collapsed && <p>{t("log_out")}</p>}
              </button>
            </li>
          </ul>
        </div>
        <Modal
          isOpen={logoutModal}
          onClose={() => setLogoutModal(false)}
          title={t("log_out") || "Log out"}
          onSubmit={onSubmit}
        >
          <div>
            <h1 className={styles.log_out}>{t("sure_to_log_out")}</h1>
          </div>
        </Modal>
      </aside>
    </>
  );
};

export default Sidebar;
